import type { OfferType } from '@Modules/offers/types';

export type AskDiscount = NonNullable<OfferType['askDiscount']>;

export type AskDiscountQuestion = AskDiscount['questions'][number];

/**
 * Mirrors the APP `AskDiscountActionType` (see `OfferDetailsPresenter.kt`):
 * - `PREFILL` fills the input with the question's message and highlights the chip.
 * - `OPEN_CHAT` — desktop deliberately diverges from the APP: the chip
 *   switches the block input to custom-amount mode (placeholder prompt,
 *   message composed from the question's `value` stem at send time) and no
 *   chat opens on click. Mobile keeps APP parity: the tap opens the full chat
 *   page with the greeting pre-filled but not sent.
 */
export const QuestionActionType = {
  PREFILL: 1,
  OPEN_CHAT: 2,
} as const;
